import { render, staticRenderFns } from "./setting-address.vue?vue&type=template&id=e32dee9c&scoped=true&"
import script from "./setting-address.vue?vue&type=script&lang=js&"
export * from "./setting-address.vue?vue&type=script&lang=js&"
import style0 from "./setting-address.vue?vue&type=style&index=0&id=e32dee9c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e32dee9c",
  null
  
)

export default component.exports